import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { TempHumiBoxContainer } from './TempHumiHi.css.js';
import { useSelector } from 'react-redux';

const HI_THRESHOLD_DANGER = 40;
const STALE_DATA_SECONDS = 300;

const TempHumiHiContainer = () => {
  const moduleList = useSelector((state) => state.modules.module);

  const moduleIds = useMemo(() => {
    return moduleList
      ?.filter(module => module.moduleScn === '2')
      .map(module => module.moduleIdx)
      .sort((a, b) => a - b) || [];
  }, [moduleList]);

  const [tempLogs, setTempLogs] = useState({});

  useEffect(() => {
    const getTempData = async () => {
      if (moduleIds.length === 0) {
        setTempLogs({});
        return;
      }
      try {
        const responses = await Promise.all(
          moduleIds.map(id => axios.get('/api/temp/newestDataOne', { params: { moduleIdx: id } }))
        );
        const newLogs = {};
        responses.forEach((response, index) => {
          const moduleId = moduleIds[index];
          if (response.data && response.data.length > 0) {
            newLogs[moduleId] = response.data[0];
          }
        });
        setTempLogs(newLogs);
      } catch (error) {
        console.error("오류 발생:", error);
      }
    };

    getTempData();
    const intervalId = setInterval(getTempData, 15000);
    return () => clearInterval(intervalId);
  }, [moduleIds]);

  return (
    <TempHumiBoxContainer>
      <table>
        <thead>
          <tr>
            <th>No.</th>
            <th>설치 번호</th>
            <th>설비명</th>
            <th>장치명</th>
            <th>온도 (°C)</th>
            <th>습도 (%)</th>
            <th>체감온도</th>
            <th>배터리 (%)</th>
            <th>수신시각</th>
          </tr>
        </thead>
        <tbody>
          {moduleIds.length > 0 ? (
            moduleIds.map((id, index) => {
              const log = tempLogs[id];
              const moduleInfo = moduleList.find(m => m.moduleIdx === id);

              if (!log) {
                return (
                  <tr key={id}>
                    <td>{index + 1}</td>
                    <td>{id}</td>
                    <td colSpan="7">데이터를 불러오는 중...</td>
                  </tr>
                );
              }

              const now = new Date();
              const logTime = new Date(log.rgstDt);
              const secondsDiff = (now.getTime() - logTime.getTime()) / 1000;
              const isStale = secondsDiff > STALE_DATA_SECONDS;

              const isDanger = log.heatIndex >= HI_THRESHOLD_DANGER;

              return (
                <tr key={log.logIdx || id} className={isStale ? 'stale-data' : ''}>
                  <td>{index + 1}</td>
                  <td>{moduleInfo?.areaNo || '미등록'}</td>
                  <td>{moduleInfo?.areaNm || '미등록'}</td>
                  <td>{moduleInfo?.modelNm || '미등록'}</td>
                  <td>{log.temp?.toFixed(1)}℃</td>
                  <td>{log.humi?.toFixed(1)}%</td>
                  <td className={isDanger ? 'danger' : ''}>
                    {log.heatIndex?.toFixed(1)}℃
                  </td>
                  <td>{log.battery}%</td>
                  <td>
                    {isStale
                      ? `미수신 (${log.rgstDt.toLocaleString()})`
                      : new Date(log.rgstDt).toLocaleString()
                    }
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9">표시할 온습도계(E-Ink/UEPL) 장치가 없습니다.</td>
            </tr>
          )}
          
        </tbody>
      </table>
    </TempHumiBoxContainer>
  );
};

export default TempHumiHiContainer;